import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IAssignDevicesPayload } from "../../../common/types/devicesTypes";
import { Status } from "../../../common/constants";
import api from "../../../api";
import { assignDevicesUrl } from "../../../config";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const ASSIGN_DEVICES: string = "assignDevices"

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null
};

interface IAssignDevicesResponse {
  message: string
}

export const assignDevices = createAsyncThunk(ASSIGN_DEVICES, async (payload: IAssignDevicesPayload, { rejectWithValue }) => {
    try {
      const response = await api.patch<IAssignDevicesResponse>(assignDevicesUrl, payload);
      const assignDevicesResponse: IAssignDevicesResponse = response.data;
      return assignDevicesResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const assignDevicesSlice = createSlice({
  name: ASSIGN_DEVICES,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(assignDevices.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(assignDevices.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(assignDevices.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export default assignDevicesSlice.reducer;